import React from 'react'
import { unSlugify } from '../../utils'

const PaymentStatus = ({status}) => {
  return (
    <span className={`inline-block text-xs px-2 py-1 rounded 
    ${status === 'PENDING' && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
    ${status === 'SUCCESSFUL' && 'bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize'}
    ${status === 'UPLOADED' && 'bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize'}
    ${status === 'FAILED' && 'bg-red-600 text-red-800 bg-opacity-10 font-outfit capitalize'}
    `}>{unSlugify(status.toLowerCase())}</span>
  )
}

export default PaymentStatus